import React from "react";
import PractitionerInfoCard from "./PractitionerInfoCard.tsx";
import { Practitioner } from "@/lib/types.ts";
import { AlertCircle } from "lucide-react";

interface PractitionerOverviewTabProps {
  practitioner: Practitioner;
  refetch: () => Promise<void>;
}

const PractitionerOverviewTab: React.FC<PractitionerOverviewTabProps> = ({
  practitioner,
}) => {
  return (
    <div className="space-y-6">
      {/* Rejection Notice */}
      {practitioner.status === "rejected" && practitioner.rejection_reason && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <AlertCircle className="h-5 w-5 text-red-500 flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-red-800 mb-1">
                Application Rejected
              </h4>
              <p className="text-sm text-red-700">
                {practitioner.rejection_reason}
              </p>
              {practitioner.rejected_at && (
                <p className="text-xs text-red-500 mt-2">
                  Rejected on{" "}
                  {new Date(practitioner.rejected_at).toLocaleDateString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    }
                  )}
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Info Cards */}
      <PractitionerInfoCard practitioner={practitioner} />
    </div>
  );
};

export default PractitionerOverviewTab;
